import { List } from 'antd';
import React from 'react';
import { dateTimeFormat, convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagem(props: any) {
  const { mensagens } = props;
  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={mensagens}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={
                <a href="#">{item.responsavel + ' - ' + convertUTCtoLocal(moment(item.createdAt)).toLocaleString()}</a>
              }
              description={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.comentario}</span>}
              className={item.tipoUsuario == 1 ? 'classeMrn' : 'classeFornecedor'}
            />
          </List.Item>
        )}
      />
    </div>
  );
}
